export const hasFeature = (features, featureName) => {
  if (!features || features.length === 0 || featureName === '') {
    return false
  }

  const featuresName = getFeaturesName(features)

  return featuresName.includes(featureName)
}

const getFeaturesName = (features) => {
  if (features.length > 0 && typeof features[0] === 'string') {
    return features
  }

  let featuresName = []

  features.forEach(feature => {
    if (feature.is_enabled) {
      featuresName.push(feature.feature_name)
    }
  })

  return featuresName
}
